/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_TitleInputs */

const en_cp_who_title = /** @type {(inputs: Cp_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students build, lecturers grade the process, the campus gets numbers`)
};

const id_cp_who_title = /** @type {(inputs: Cp_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa mengerjakan, dosen menilai proses, kampus dapat angka`)
};

/**
* | output |
* | --- |
* | "Students build, lecturers grade the process, the campus gets numbers" |
*
* @param {Cp_Who_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_title = /** @type {((inputs?: Cp_Who_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_title(inputs)
	return en_cp_who_title(inputs)
});